export default __webpack_public_path__ + "static/media/14KYCDetailsYono2.51328264.png";